import { z } from "zod";

const BASE_URL = import.meta.env["VITE_API_BASE_URL"] ?? "/api";
const API_MODE = import.meta.env["VITE_API_MODE"] ?? "dynamic";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function apiGet<T>(path: string, schema: z.ZodType<T>): Promise<T> {
  const url = `${BASE_URL}${API_MODE === "static" ? staticApiPath(path) : path}`;
  const res = await fetch(url, {
    headers: { accept: "application/json" },
  });
  if (!res.ok) {
    throw new ApiError(res.status, `GET ${path} -> ${res.status}`);
  }
  const json: unknown = await res.json();
  return schema.parse(json);
}

export function staticApiPath(path: string): string {
  const [rawPathname, search] = path.split("?", 2);
  const pathname = rawPathname ?? "";
  const suffix = search ? `?${search}` : "";

  if (pathname === "/profile" || pathname === "/publications") {
    return `${pathname}.json${suffix}`;
  }
  if (pathname === "/posts") {
    return `/posts.json${suffix}`;
  }
  if (pathname.startsWith("/posts/")) {
    return `${pathname}.json${suffix}`;
  }
  return `${pathname}.json${suffix}`;
}
